import $ from 'jquery';

$(document).ready(function () {
    $(document).on('click', '#show-csv-file-data', function (e) {
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        $('#csv-file-table').html('');

        let form = $('#csv-file-form');
        let action = form.attr('action');
        let formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                if (data.success) {
                    $('#csv-error-messages').hide(200);
                    $('#csv-file-table').html(data.table);
                    $('#csv-file-table-tab-link').tab('show');
                    $('#csv-file-save-info-messages').hide();

                    if (data.advertList) {
                        let advertNames = [];

                        for(let item of data.advertList) {
                            var quickArr =  [item.ad_id, item.program_id, item.created];
                            advertNames.push(quickArr);
                        }

                        $('.autocomplete-inputs').each(function () {
                            autocomplete(this, advertNames);
                        });
                    }

                    if (data.client || data.marketId) {
                        messages = [];

                        if (data.client) {
                            messages.push(`Selected Client is ${data.client.client_name} (${data.client.client_id})`);
                        }
                        if (data.marketId) {
                            messages.push(`Selected Market ID is ${data.marketId}`);
                        }

                        $('#csv-file-save-info-messages').html(messages.join('<br>')).fadeIn();
                    }

                } else {
                    $('#csv-error-messages').html(data.errors.join('<br>')).fadeIn();
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function() {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });

    });

    $(document).on('click', '#save-csv-file-data', function (e) {
        e.preventDefault();

        let button = $(this);
        let backButton = $('#show-csv-file-form');

        button.attr('disabled', true);
        backButton.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let form = $('#csv-file-form');
        let saveForm = $('#save-csv-file-form');
        let action = saveForm.attr('action');
        let formData = new FormData(form[0]);

        let selectedHeader = $('#csv-file-table-form').serializeArray();
        formData.append('selected_header', JSON.stringify(selectedHeader));

        let advertIds = [];

        $('.autocomplete-inputs').each(function (k) {
            advertIds.push($(this).val());
        });

        formData.append('advert_ids', JSON.stringify(advertIds));

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                button.attr('disabled', false);
                backButton.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                if (data.success) {
                    $('#csv-file-save-success-messages').html(data.messages.join('<br>')).fadeIn();
                    $('#csv-file-save-error-messages').hide(200);
                    $('#csv-file-messages-tab-link').tab('show');

                } else {
                    $('#csv-file-save-error-messages').html(data.errors.join('<br>')).fadeIn();
                }
            },
            error: function() {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).on('click', '#show-csv-file-form', function (e) {
        $('#csv-file-save-error-messages').hide(200);
        $('#csv-file-form-tab-link').tab('show');
    });

    // Last Adverts

    $(document).on('click', '.last-advert-select-button', function (e) {
        e.preventDefault();
        let el = $(this);
        let advertName = $.trim(el.text());
        el.parent().parent()
            .find('.autocomplete-inputs')
            .val(advertName);
    });

    $(document).on('click', '.last-adverts-list-toggle-button', function (e) {
        e.preventDefault();
        let el = $(this);
        let list = el.parent().find('.last-adverts-list');
        if ($(list).is(':hidden')) {
            list.show(300);
        } else {
            list.hide(300);
        }
    });

    $(document).on('click', '#create_client', function (e) {
        $('#client_key_id').val(generateUUID());
    });

    $(document).on('click', '#reset_key', function (e) {
        e.preventDefault();
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();
        $('#client_key').val(generateUUID());
        setTimeout(function () {
            button.attr('disabled', false);
            button.find('.fa').hide();
            button.find('.fa-check').show();
        }, 200);
    });

    /**
     * Function to produce UUID.
     */
    function generateUUID()
    {
        var d = new Date().getTime();

        if( window.performance && typeof window.performance.now === "function" )
        {
            d += performance.now();
        }

        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
        {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });

        return uuid;
    }

    // Autocomplete
    function autocomplete(inp, arr) {
        let currentFocus;
        inp.addEventListener("input", function(e) {
            let a, b, i, val = this.value;
            closeAllLists();
            if (!val) { return false;}
            currentFocus = -1;
            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            this.parentNode.appendChild(a);

            for (i = 0; i < arr.length; i++) {
                if (arr[i][1].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                    b = document.createElement("DIV");
                    let string = arr[i][1] + " " + arr[i][2];
                    b.innerHTML = "<strong>" + string.substr(0, val.length) + " </strong>";
                    b.innerHTML += string.substr(val.length);
                    b.innerHTML += "<input type='hidden' value='" + arr[i][1] + " / " + arr[i][2] + " / " + arr[i][0] +"'>";
                    b.addEventListener("click", function(e) {
                        inp.value = this.getElementsByTagName("input")[0].value;
                        closeAllLists();
                    });
                    a.appendChild(b);
                }
            }
        });
        inp.addEventListener("keydown", function(e) {
            var x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode == 40) {
                currentFocus++;
                addActive(x);
            } else if (e.keyCode == 38) { //up
                currentFocus--;
                addActive(x);
            } else if (e.keyCode == 13) {
                e.preventDefault();
                if (currentFocus > -1) {
                    if (x) x[currentFocus].click();
                }
            }
        });
        function addActive(x) {
            if (!x) return false;
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            x[currentFocus].classList.add("autocomplete-active");
        }
        function removeActive(x) {
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }
        function closeAllLists(elmnt) {
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                if (elmnt != x[i] && elmnt != inp) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }

    $(".last-navbar").click(function () {
       $(this).parents('li').toggleClass('show');
       $(this).attr('aria-expanded', !$(this).attr('aria-expanded'));
       $(this).next().toggleClass('show');
    });
});
